/**
 * Arquivo: src/main.tsx
 * Versão: 4.10.55
 * Data: 11/09/2026
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import PwaUpdateNotice from './components/PwaUpdateNotice'
import './styles/pwa-update.css'
import './styles/global.css'
import './styles/movements.css'
import './styles/filters.css'
import { registrarPWA } from './pwa'

registrarPWA()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <PwaUpdateNotice />
    </BrowserRouter>
  </React.StrictMode>,
)

